// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectDevice_wrapper__xT9MS","tips":"SelectDevice_tips__ku0HE","red":"SelectDevice_red__XLR6e"};